import React from "react";
import { Phone, Heart } from "lucide-react";
import { Button } from "./ui/button";
import { clinicInfo } from "../data/mock";

const Hero = () => {
  const scrollToAppointment = () => {
    const element = document.getElementById("appointment");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${clinicInfo.whatsapp}`, "_blank");
  };

  return (
    <section id="home" className="relative pt-24 pb-20 px-4 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-20 right-10 w-72 h-72 bg-purple-200 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute bottom-10 left-10 w-96 h-96 bg-violet-200 rounded-full opacity-20 blur-3xl"></div>
      </div>

      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 px-4 py-2 rounded-full text-sm font-medium">
              <Heart className="w-4 h-4" />
              Cuidados veterinários com amor
            </div>

            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
              Seu pet merece o
              <span className="text-purple-600"> melhor cuidado</span>
            </h1>

            <p className="text-lg text-gray-600 leading-relaxed">
              Na Natalia Regina VetClin, tratamos cada animal com carinho e
              profissionalismo. Consultas, cirurgias, vacinação e muito mais
              para o bem-estar do seu melhor amigo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              {/* <Button 
                size="lg"
                onClick={scrollToAppointment}
                className="bg-purple-600 hover:bg-purple-700 text-white text-lg px-8 py-6"
              >
                <Phone className="w-5 h-5 mr-2" />
                Agendar Consulta
              </Button> */}

              <Button
                size="lg"
                variant="outline"
                onClick={handleWhatsApp}
                className="border-purple-600 text-purple-600 hover:bg-purple-50 text-lg px-8 py-6"
              >
                WhatsApp
              </Button>
            </div>

            {/* Contact Info */}
            <div className="flex flex-col sm:flex-row gap-6 pt-6 border-t border-gray-200">
              <div>
                <p className="text-sm text-gray-500">Telefone</p>
                <a
                  href={`tel:${clinicInfo.phone}`}
                  className="text-purple-600 font-semibold hover:underline"
                >
                  (11) 94932-1508
                </a>
              </div>
              <div>
                <p className="text-sm text-gray-500">Email</p>
                <a
                  href={`mailto:${clinicInfo.email}`}
                  className="text-purple-600 font-semibold hover:underline"
                >
                  {clinicInfo.email}
                </a>
              </div>
            </div>
          </div>

          {/* Image/Illustration */}
          <div className="relative">
            <div className="relative bg-purple-100 rounded-3xl p-8 aspect-square flex items-center justify-center">
              <div className="text-center space-y-4">
                <div className="w-48 h-48 mx-auto bg-white rounded-full flex items-center justify-center shadow-lg">
                  {/* <img 
                    src="https://customer-assets.emergentagent.com/job_heart-paws-vet/artifacts/yu8d4sa5_ChatGPT%20Image%202%20de%20nov.%20de%202025%2C%2018_55_34.png" 
                    alt="Logo Natalia Regina VetClin" 
                    className="w-32 h-32 object-contain"
                    style={{ filter: 'brightness(0) saturate(100%) invert(31%) sepia(89%) saturate(2715%) hue-rotate(258deg) brightness(91%) contrast(92%)' }}
                  /> */}
                  <img
                    src="https://nataliareginavetclin.com.br/veterinaria.jpg"
                    alt="Logo Natalia Regina VetClin"
                    className="w-32 h-32 object-contain"
                  />
                </div>
                <p className="text-2xl font-bold text-purple-900">
                  Dra. Natalia Regina
                </p>
                <p className="text-purple-700">Médica Veterinária</p>
              </div>
            </div>

            {/* Floating cards */}
            <div className="absolute -top-6 -left-6 bg-white rounded-xl shadow-lg p-4 max-w-[200px] transform hover:scale-105 transition-transform">
              <p className="text-sm font-semibold text-gray-800">
                +500 Pets Atendidos
              </p>
              <p className="text-xs text-gray-500 mt-1">Com amor e dedicação</p>
            </div>

            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-lg p-4 max-w-[200px] transform hover:scale-105 transition-transform">
              <p className="text-sm font-semibold text-gray-800">
                Atendimento de Excelência
              </p>
              <p className="text-xs text-gray-500 mt-1">
                Equipamentos modernos
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
